import { render, staticRenderFns } from "./TrainingEvents.vue?vue&type=template&id=43e64840&"
import script from "./TrainingEvents.vue?vue&type=script&lang=js&"
export * from "./TrainingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports